module.exports = __webpack_public_path__ + "static/media/exp-date.977d06ff.svg";